"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getResponsiveStep = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/sort"));

/**
 * Find the index of a `ResponsiveMode` which most closely matches an array of
 * `ResponsiveMode` steps. The index is the exact match, or the index of the
 * closest _larger_ mode.
 */
var getResponsiveStep = function getResponsiveStep(mode, steps) {
  var _context;

  var sorted = (0, _sort.default)(_context = (0, _toConsumableArray2.default)(steps)).call(_context);
  var step = 0;

  while (step < sorted.length && sorted[step] < mode) {
    ++step;
  }

  return step;
};

exports.getResponsiveStep = getResponsiveStep;